export const POST_SUBMIT_REGISTRATION_STEP = "postSubmitRegistration";

export const DONE_STEP = "done";

export const ACCOUNT_REGISTRATION_URL = "/accounts#/register";

export function routeStepForAccountSession(stepName, accountSignedIn = false) {
  if (accountSignedIn && stepName === POST_SUBMIT_REGISTRATION_STEP) return DONE_STEP;
  return stepName;
}

export function postSubmitStepForPayloads(payloads, accountSignedIn = false) {
  if (accountSignedIn) return DONE_STEP;
  return Array.isArray(payloads) && payloads.length > 0
    ? POST_SUBMIT_REGISTRATION_STEP
    : DONE_STEP;
}
